import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, MessageCircle, Phone, X } from "lucide-react";
import { company, navItems, whatsappUrl } from "@/data/siteData";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname, location.hash]);
  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-shell">
        <Link to="/" className="brand-lockup" data-testid="header-home-link" aria-label="Suha Builders home">
          <span className="brand-mark">S</span><span><strong>Suha Builders</strong><small>Part of Maas Group</small></span>
        </Link>
        <nav className="desktop-nav" aria-label="Primary navigation">
          {navItems.map((item) => <NavLink key={item.to} to={item.to} end={item.to === "/"} data-testid={`header-nav-${item.label.toLowerCase().replaceAll(" ", "-")}`}>{item.label}</NavLink>)}
          <Link to="/#locations" data-testid="header-nav-locations">Locations</Link>
        </nav>
        <div className="header-actions">
          <a href={`tel:${company.phone}`} className="icon-link" aria-label={`Call ${company.phoneDisplay}`} data-testid="header-phone-link"><Phone size={17} /></a>
          <a href={whatsappUrl} target="_blank" rel="noreferrer" className="icon-link" aria-label="Message on WhatsApp" data-testid="header-whatsapp-link"><MessageCircle size={17} /></a>
          <Link to="/contact" className="button button-coral" data-testid="header-contact-link">Start a project</Link>
        </div>
        <button type="button" className="menu-toggle" onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-label={open ? "Close menu" : "Open menu"} data-testid="mobile-menu-button">{open ? <X /> : <Menu />}</button>
      </div>
      {open && (
        <nav className="mobile-nav" aria-label="Mobile navigation" data-testid="mobile-navigation">
          {navItems.map((item) => <NavLink key={item.to} to={item.to} end={item.to === "/"} data-testid={`mobile-nav-${item.label.toLowerCase().replaceAll(" ", "-")}`}>{item.label}</NavLink>)}
          <Link to="/#locations" data-testid="mobile-nav-locations">Locations</Link>
          <Link to="/contact" className="mobile-contact" data-testid="mobile-nav-contact">Start a project</Link>
        </nav>
      )}
    </header>
  );
};
